import { bootstrap } from './framework/bootstrap.fn';
import { ScreenCorderApplication } from './screencorder.app';

bootstrap(ScreenCorderApplication);
